export const CUSTOM_TEMPLATE_ADD_EDIT_MODAL_ID =
  'custom-template-add-edit-modal';

export const TEMPLATE_TYPE_QUERY_PARAM = 'templateType';

export const LANGUAGE_QUERY_PARAM = 'language';
